import React, { useState } from "react";
import ContentHeader from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import "./Stock.css";
import ProductNavigation from "../../components/StockComp/StockNavigation";
import ProductContent from "../../components/StockComp/StockContent";

const Product = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <ContentHeader setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <ProductNavigation />
        </div>
        <div className="content-index">
          <ProductContent />
        </div>
      </div>
    </div>
  );
};

export default Product;
